import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useI18n } from "@/i18n";

export const CookieNotice = () => {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("gj_cookie_notice")) return undefined;
    const id = setTimeout(() => setShow(true), 1400);
    return () => clearTimeout(id);
  }, []);
  const accept = () => {
    localStorage.setItem("gj_cookie_notice", "1");
    setShow(false);
  };
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          role="region"
          aria-label={t.cookie.link}
          data-testid="cookie-notice"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          className="fixed bottom-3 left-3 right-3 z-[55] border border-white/15 bg-ink-2/95 p-4 backdrop-blur-xl sm:bottom-4 sm:left-4 sm:right-auto sm:max-w-sm sm:p-5"
        >
          <p className="text-xs leading-relaxed text-zinc-300 sm:text-sm">{t.cookie.text}</p>
          <div className="mt-3 flex items-center justify-between sm:mt-4">
            <Link to="/legal/cookies" data-testid="cookie-policy-link" className="text-sm text-bone underline decoration-signal underline-offset-4">{t.cookie.link}</Link>
            <button data-testid="cookie-accept-button" onClick={accept} className="rounded-full bg-bone px-5 py-2 text-sm font-medium text-ink transition-colors hover:bg-signal">{t.cookie.ok}</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
